export class GateOut{
    public gate_entry_no! :string;
    public total_net_weight!:string
    public total_gross_weight!:string
    public remark_1!:string
    public remark_2!:string
}